import { Box, styled } from "@mui/material";

export const S = {
    AssetType: styled(Box)(({ theme }) => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: theme.spacing(15),
        paddingBottom: theme.spacing(15),
        fontWeight: "bold",
        fontSize: 24,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        width: "100%",
        height: "100%",
    })),
};
